import { render, staticRenderFns } from "./auto-add.vue?vue&type=template&id=2d7fec18&scoped=true&"
import script from "./auto-add.vue?vue&type=script&lang=js&"
export * from "./auto-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7fec18",
  null
  
)

export default component.exports